import React from "react";
import InputCheckbox from "../../components/InputCheckbox";
import Input from "../../components/Input";
import InputNumberOnly from "../../components/InputNumberOnly";
import { Upload, message, Button, Row, Col, Typography } from "antd";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import {
  setItem,
  removeItem,
  getItem,
  getPaymentUser,
  getPaymentGroup,
  formatAmount,
  labelsPerFrequency,
} from "utils";
import checkCircle from "../../assets/img/check-circle.png";
import checkCircleDefault from "../../assets/img/check-circle-default.png";
import { useDraggable } from "react-use-draggable-scroll";
import { useParams } from "react-router-dom";
import { Radio } from "antd";

import { AiOutlineCheck } from "react-icons/ai";
import { FaAward } from "react-icons/fa";

import Plan from "../../components/Plan"
import BenefitItem from "../../components/BenefitItem"

export default function FormPlans({
  register,
  errors,
  control,
  onPrevious,
  onNext,
  getValues,
  setValue,
  loading,
  setSelectedPlan,
}) {
  const { Text, Title } = Typography;

  const ref = React.useRef(); // We will use React useRef hook to reference the wrapping div:
  const { events } = useDraggable(ref); // Now we pass the reference to the useDraggable hook:
  const [selected, setSelected] = React.useState(null);
  const [plans, setPlans] = React.useState([]);
  const [planDetails, setPlanDetails] = React.useState({});
  const [yearlyDiscount, setYearlyDiscount] = React.useState(null);

  const { paymentGroupId } = useParams();

  React.useEffect(() => {
    async function getPlans() {
      const companyId = await getItem("companyId");

      const {
        data: { data: dataPlans },
      } = await getPaymentGroup({
        companyId,
        id: paymentGroupId,
      });

      let paymentFrequency = dataPlans[0].paymentTypes;

      const templateOrder = ["YEARLY", "SEMIANNUALLY", "QUARTERLY", "MONTHLY"];

      function sortFunc(a, b) {
        return (
          templateOrder.indexOf(a.frequency) -
          templateOrder.indexOf(b.frequency)
        );
      }

      const sortedPlans = paymentFrequency.filter(p => p).sort(sortFunc);
      setPlanDetails(dataPlans[0].detail);
      setPlans(sortedPlans);

      const yearlyPayment = paymentFrequency.find(
        (i) => i.frequency === "YEARLY"
      );
      const monthlyPayment = paymentFrequency.find(
        (i) => i.frequency === "MONTHLY"
      );

      if (yearlyPayment && monthlyPayment) {
        const discount = {
          value: monthlyPayment?.value * 12 - yearlyPayment?.value,
          percentage: Math.abs(
            Math.ceil((monthlyPayment?.value / yearlyPayment?.value) * 100)
          ),
        };
        setYearlyDiscount(discount);
      }
    }

    getPlans();
  }, []);

  React.useEffect(() => {
    const p = plans.find((p) => p.id === selected);
    setValue("selectedPlan", p);
  }, [selected]);

  const handleNext = () => {
    if (!selected) {
      message.error("Por favor, selecione um plano");
    } else {
      onNext();
    }
  };

  return (
    <div key="plans">
      {/* <Title level={2}>Selecione seu plano</Title> */}

      <Radio.Group
        onChange={(event) => {
          setSelected(event.target.value);
        }}
        value={selected}
        style={{ display: "block" }}
      >
        <div {...events} ref={ref} className="__signup-embed-plan-container">
          {plans.length === 0 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
                height: "400px",
              }}
            >
              <LoadingOutlined style={{ alignSelf: "center", fontSize: 40 }} />
            </div>
          )}

          {plans.map((item) => (
            <Plan
              {...item}
              plans={plans}
              selected={selected === item.id}
              setSelected={setSelected}
              id={item.id}
              key={item.id}
              planDetails={planDetails}
              yearlyDiscount={yearlyDiscount}
            />
          ))}
        </div>
      </Radio.Group>
      <Row gutter={16} className="__signup-bottom-button">
        <Col xs={12}>
          <button type="button" className="__auth-button-outlined" disabled>
            Voltar
          </button>
        </Col>
        <Col xs={12}>
          <button
            type="button"
            className="__auth-button-primary"
            disabled={loading}
            onClick={() => handleNext()}
          >
            {loading ? <LoadingOutlined /> : "Próximo"}
          </button>
        </Col>
      </Row>
    </div>
  );
}



